import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Rise, Words, EASE } from "../components/Reveal";
import { COPY } from "../content/copy";
import { ImageTrigger } from "../components/viewer/ImageTrigger";
import { SERVICE_IMAGES } from "../components/viewer/galleries";

const Row = ({ item, i, isOpen, onToggle }) => (
    <div className={`svc ${isOpen ? "open" : ""}`}>
        <button
            className="svc-row"
            data-testid={`svc-row-${i}`}
            data-cursor
            aria-expanded={isOpen}
            aria-controls={`svc-panel-${i}`}
            onClick={onToggle}
        >
            <span className="svc-num">{String(i + 1).padStart(2, "0")}</span>
            <span className="svc-title">
                <span className="svc-title-up">{item.title}</span>
                <span className="svc-title-it" aria-hidden="true">
                    {item.title}
                </span>
            </span>
            <span className="svc-plus" aria-hidden="true">
                <span />
                <span />
            </span>
        </button>
        <AnimatePresence initial={false}>
            {isOpen && (
                <motion.div
                    className="svc-panel"
                    id={`svc-panel-${i}`}
                    initial={{ height: 0 }}
                    animate={{ height: "auto" }}
                    exit={{ height: 0 }}
                    transition={{ duration: 0.8, ease: EASE }}
                    data-testid={`svc-panel-${i}`}
                >
                    <div className={`svc-panel-inner ${item.image ? "has-image" : ""}`}>
                        <p className="svc-text">
                            <Words text={item.text} delay={0.12} stagger={0.018} inView={false} />
                        </p>
                        {item.image && (
                            <motion.figure className="svc-image" initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.9, ease: EASE, delay: 0.25 }} data-testid={`svc-image-${i}`}>
                                <ImageTrigger images={SERVICE_IMAGES} index={SERVICE_IMAGES.findIndex((image) => image.src === item.image.src)} testId={`svc-image-open-${i}`}>
                                    <img src={item.image.src} alt={item.image.alt} loading="lazy" />
                                </ImageTrigger>
                                <figcaption className="caption">{item.image.alt}</figcaption>
                            </motion.figure>
                        )}
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    </div>
);

export default function Servizi() {
    const [open, setOpen] = useState(null);
    const s = COPY.servizi;

    return (
        <section className="section" data-testid="servizi-block">
            <div className="container">
                <Rise>
                    <p className="caption">{s.caption}</p>
                </Rise>
                <Rise delay={0.05}>
                    <h2 className="h2 section-title" data-testid="servizi-title">
                        <Words text={s.titleA} />{" "}
                        <Words text={s.titleB} italic />
                    </h2>
                </Rise>
                <Rise delay={0.1}>
                    <p className="lead section-lead">{s.lead}</p>
                </Rise>
                <div className="svc-list">
                    {s.items.map((item, i) => (
                        <Rise key={item.title} delay={i * 0.05}>
                            <Row
                                item={item}
                                i={i}
                                isOpen={open === i}
                                onToggle={() => setOpen(open === i ? null : i)}
                            />
                        </Rise>
                    ))}
                </div>
            </div>
        </section>
    );
}
